var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 29.3337C18.6374 29.3337 21.2153 28.5517 23.4079 27.0866C25.6006 25.6215 27.3096 23.5391 28.3187 21.1028C29.3279 18.6664 29.5919 15.9855 29.0775 13.3991C28.563 10.8127 27.2931 8.43694 25.4284 6.57224C23.5637 4.70754 21.1879 3.43766 18.6015 2.92319C16.0151 2.40872 13.3342 2.67277 10.8979 3.68194C8.46153 4.69111 6.37915 6.40007 4.91406 8.59273C3.44898 10.7854 2.66699 13.3632 2.66699 16.0003C2.67719 19.5334 4.08523 22.9189 6.5835 25.4172C9.08178 27.9154 12.4672 29.3235 16.0003 29.3337V29.3337Z",
    stroke: "#464853",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2266 19.7732L19.7732 12.2266",
    stroke: "#464853",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7732 19.7732L12.2266 12.2266",
    stroke: "#464853",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close_circle.192e804c.svg";
export { ForwardRef as ReactComponent };